import { render, staticRenderFns } from "./race.vue?vue&type=template&id=7005cf6e&scoped=true&lang=pug"
import script from "./race.vue?vue&type=script&lang=ts"
export * from "./race.vue?vue&type=script&lang=ts"
import style0 from "./race.vue?vue&type=style&index=0&id=7005cf6e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7005cf6e",
  null
  
)

export default component.exports